import "./clientServices.css";

const services = [
  {
    category: "Accounting Services",
    description: `Providing financial information to our clients in a timely and accurate manner is a commitment that we feel cannot be compromised. Meaningful, well-organized financial records ensure that your business operations will run more efficiently on a daily basis. Our firm provides a full range of cost effective accounting services including the following:`,
    items: [
      "General ledger & financial statement preparation",
      "Bookkeeping (Monthly/Quarterly/Annual)",
      "Compilation of financial statements",
      "Cash flow & budgeting analysis",
      "Accounting forecasts & projections",
    ],
  },
  {
    category: "Consulting Services",
    description: `We gauge our worth by the personal and business successes of our clients. We can help your business identify areas negatively affecting profitability and growth and develop solutions that are practical and technically sound. In addition to acting as a sounding board for management, we provide comprehensive, flexible strategies that address the issues affecting your business. The following are just a few of the areas in which we provide consulting services:`,
    items: [
      "Accounting software selection and implementation",
      "Business process improvement",
      "Computer systems",
      "Financial & retirement planning",
      "Estate planning",
    ],
  },
  {
    category: "Tax Services",
    description: `We prefer to take a proactive vs. reactive approach to tax services. By keeping current on new tax laws and legislation, we are in a position to identify key tax planning opportunities that minimize both your current and future tax liabilities. We provide our individual and business clients with the taxation expertise and knowledge that they deserve throughout the year. Tax services offered include, but are not limited to:`,
    items: [
      "Tax planning for individuals and corporations",
      "Return preparation for: Individuals - Corporations - Estates and trusts",
      "Provincial and federal commodity tax planning and compliance",
      "Tax considerations in matrimonial settlements",
      "Tax effects of buying/selling a business",
      "Tax effective retirement and estate planning",
    ],
  },
];

export default function ClientServices() {
  return (
    <section className="client-services">
      <h2>Client Services</h2>
      <p className="client-services-page-description">
        Our firm offers a wide range of services to our individual and business clients. Our clients benefit from personalized, quality service that is beyond comparison.
        We have listed the services that we offer to our clients with a brief description.
      </p>
      <p className="client-services-page-description">
        As the list below is by no means comprehensive, please feel free to inquire about a service if you do not see it listed.
      </p>

      <div className="client-services-services-navigation">
        {services.map((s) => (
          <a key={s.category} href={`#${s.category.replace(/\s/g, "-")}`} className="client-services-nav-link">
            {s.category}
          </a>
        ))}
      </div>

      {services.map((s) => (
        <div key={s.category} className="client-services-service-section" id={s.category.replace(/\s/g, "-")}>
          <h2 className="client-services-service-title">{s.category}</h2>
          <p className="client-services-service-description">{s.description}</p>
          <ul className="client-services-service-list">
            {s.items.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
